module.exports = __webpack_public_path__ + "static/media/forever_tricolour_small_3.7eff6267.jpg";